import { IPitchFilter, IPitchValue } from "../abstraction/IPitchFilter";

export class MultiFilter implements IPitchFilter {

    constructor(...filters: IPitchFilter[]) {
        this.filters = filters;
    }

    processSample(value: IPitchValue): IPitchValue {

        for (const filter of this.filters)
            value = filter.processSample(value);

        return value;
    }
      
    readonly filters: IPitchFilter[];

    readonly rawData: IPitchValue[] = [];

}